export const toCartFromCardEventExtra = () => {
    return { component: 'material-card', location: window.location.href };
};
